/**
 * /scope — thin React wrapper.
 *
 * We load the actual P7 UI from /p7.html (served statically by React's dev
 * server / nginx). React's only job here is to enforce auth before the
 * browser swaps to the HTML prototype.
 *
 * The legacy multi-card ScopeChat / intake modal / resume-or-new picker are
 * retained at /scope-chat for rollback and comparison, but /scope itself is
 * now the P7 build.
 */
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ScopePage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (loading) return;
    if (user === false) {
      navigate(`/login?next=${encodeURIComponent('/scope')}`);
      return;
    }
    if (user) {
      // Forward any ballpark-handoff params through to the P7 bundle so the
      // intake modal can pre-fill address + postcode and the user only has
      // to type their name.
      const passthrough = ['draft', 'address', 'postcode', 'name'];
      const qs = passthrough
        .map((k) => [k, searchParams.get(k)])
        .filter(([, v]) => !!v)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
      window.location.replace(`/p7.html${qs ? '?' + qs : ''}`);
    }
  }, [user, loading, navigate, searchParams]);

  return (
    <div style={{ padding: 60, textAlign: 'center', color: '#64748B' }} data-testid="scope-loading">
      Loading SCOPE…
    </div>
  );
}
